/* tslint:disable */
/* eslint-disable */
/* @relayHash e639524986ff902f5cec302afbff7f0e */

import { ConcreteRequest } from "relay-runtime";
export type PortfolioItemsAction = "ADD" | "EDIT" | "REMOVE" | "REORDER" | "%future added value";
export type PortfolioType = "CART" | "HEART" | "%future added value";
export type ModifyPortfolioItemsInput = {
    action: PortfolioItemsAction;
    endPortfolioItemId?: string | null;
    itemsIds?: Array<string | null> | null;
    note?: string | null;
    portfolioItemsIds?: Array<string | null> | null;
    portfolioId?: string | null;
    portfolioType?: PortfolioType | null;
    startPortfolioItemId?: string | null;
    targetPortfolioItemId?: string | null;
    userId: string;
    clientMutationId?: string | null;
};
export type staticTileHelpersModifyPortfolioItemsMutationVariables = {
    input: ModifyPortfolioItemsInput;
};
export type staticTileHelpersModifyPortfolioItemsMutationResponse = {
    readonly modifyPortfolioItems: {
        readonly __typename: string;
    } | null;
};
export type staticTileHelpersModifyPortfolioItemsMutation = {
    readonly response: staticTileHelpersModifyPortfolioItemsMutationResponse;
    readonly variables: staticTileHelpersModifyPortfolioItemsMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ModifyPortfolioItemsPayload",
    "kind": "LinkedField",
    "name": "modifyPortfolioItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "staticTileHelpersModifyPortfolioItemsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "staticTileHelpersModifyPortfolioItemsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-finding/326.0.0-2021-08-04T21:25:51.476Z/staticTileHelpersModifyPortfolioItemsMutation",
    "metadata": {},
    "name": "staticTileHelpersModifyPortfolioItemsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '629cb85bb84efa685f35f7e7c3108eb8';
export default node;
